import { LOCALE, CURRENCY } from 'constants/locale'

const formatAmount = (value: number) => {
  return Intl.NumberFormat(LOCALE, {
    style: 'currency',
    currency: CURRENCY,
  }).format(value)
}

export default formatAmount
